import React, { useState, useEffect } from "react";
import { Button, IconButton, Checkbox, TextField, Grid, Paper, styled, Container, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from "axios";
import routes from "routes";
import { toast } from "react-toastify";
import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { KeyboardBackspace as KeyboardBackspaceIcon } from '@material-ui/icons';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const useStyles = makeStyles((theme) => ({
    inputRoot: {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "red",
            color: "red"
        }
    },
    repcont: {
        textAlign: 'center',
    },
    repbtn: {
        float: 'left',

    },
    reptitle: {
        display: 'inline-block',
        marginTop: '10px'
    }
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

{/**This component is used to edit the auto generated report. */ }
function EditableAutomationReportSystem(props) {
    const classes = useStyles();
    const agencyNameOptions = [];
    const searchEngineOption = [];

    if (props.editableReportData.adprovider !== "") {
        let items = props.editableReportData.adprovider.split(",");
        for (let i = 0; i < items.length; i++) {
            searchEngineOption.push({ title: items[i], value: items[i] })
        }
    }

    const searchEngineOptions = [{ title: 'GOOGLE', value: 'GOOGLE' }, { title: 'BING', value: 'BING' }];

    for (let i = 0; i < props.agencyName.length; i++) {
        agencyNameOptions.push({ id: props.agencyName[i][0], agency: props.agencyName[i][1] })
    }
    const [btnStatus, setBtnStatus] = useState(false);
    const [reportName, setReportName] = useState(props.editableReportData.reportname);
    const [agencyName, setAgencyName] = useState(props.editableReportData.agencyname);
    const [agencyId, setAgencyId] = useState(props.editableReportData.agencyid);
    const [brandName, setBrandName] = useState(props.editableReportData.brandid);
    const [searchEngine, setSearchEngine] = useState(props.editableReportData.adprovider != "" ? props.editableReportData.adprovider.split(",") : []);
    const [advertiser, setAdvertiser] = useState(props.editableReportData.adhost != "" ? props.editableReportData.adhost.split(",") : []);
    const [brandedUrl, setBrandedUrl] = useState(props.editableReportData.adbrandedurl != "" ? props.editableReportData.adbrandedurl.split(",") : []);
    const [isReportNameEmpty, setIsReportNameEmpty] = useState(false);
    const [isAgencyNameEmpty, setIsAgencyNameEmpty] = useState(false);
    const [isBrandNameEmpty, setIsBrandNameEmpty] = useState(false);

    const handleAgencyName = (event, value, reason, details) => {
        setIsAgencyNameEmpty(false);
        if (value !== null) {
            setAgencyName(value.agency);
            setAgencyId(value.id);
            props.setBrandId(value.id)

        } else {
            setAgencyName('');
            setAgencyId('');
            props.setBrandId('')
        }

    }
    const handleBrandName = (event, value, reason, details) => {
        setIsBrandNameEmpty(false)
        if (value !== null) {
            setBrandName(value.id);

        } else {
            setBrandName('');
        }

    }
    const handleSearchEngine = (event, value, reason, details) => {

        let arr = [];
        if (value.length > 0) {

            for (let i = 0; i < value.length; i++) {
                arr.push(value[i].value)
            }
            setSearchEngine(arr);
        } else {
            setSearchEngine([])
        }

    }
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const handleReportSubmit = async (event) => {
        setBtnStatus(true);
        const report = {
            "reportType": props.report,
            "adhostTemp": [],
            "createdAt": props.editableReportData.createdAt,
            "id": props.editableReportData.id,
            "reportname": reportName,
            "agencyname": agencyName,
            "agencyid": agencyId,
            "brandid": brandName,
            "adprovider": searchEngine,
            "adhost": advertiser,
            "adbrandedurl": brandedUrl,
            "brandedUrlStatus": null,
            "searchTerm": null,
            "hijackAdHostList": [],
            "brandedUrlList": [],
            "brandedUrlValue": null
        }

        if ((reportName != '' && agencyName != '' && brandName != '')) {
            await axios({
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                url: `${routes.scheduleReport.endpoint}/saveQueryParam`,
                data: JSON.stringify(report)
            }).then((response) => {
                if (response.status == 200) {
                    notify();
                    setReportName('');
                    setAgencyName('');
                    setBrandName('');
                    setSearchEngine([]);;
                    setAdvertiser([]);
                    setBrandedUrl([]);
                    setBtnStatus(false);
                    props.resetEditId();
                    props.triggerRefresh();
                }

            })
                .catch(error => {
                    console.log(error);
                    setBtnStatus(false);
                })
        } else {
            if (reportName == '') { setIsReportNameEmpty(true) }
            if (agencyName == '') { setIsAgencyNameEmpty(true) }
            if (brandName == '') { setIsBrandNameEmpty(true) }
            setBtnStatus(false);
            return;
        }
    }
    const notify = () => toast.success('Successfully Saved', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });;

    return <>
        <div>
            <Container className={classes.repcont} >
                <Typography variant="h3" gutterBottom component="div" className={classes.reptitle} >
                    WELCOME TO AUTOMATION REPORT SYSTEM
                </Typography>
            </Container>
            <Grid container spacing={4} className="mb-2" >
                <Grid item xs={4}>
                    <TextField
                        value={reportName}
                        defaultValue={reportName}
                        id="standard-basic"
                        label="Report Name*"
                        variant="standard"
                        fullWidth="true"
                        error={isReportNameEmpty}
                        onChange={(event) => { setReportName(event.target.value); setIsReportNameEmpty(false) }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Autocomplete
                        defaultValue={(agencyNameOptions.filter((value) => value.agency == props.editableReportData.agencyname))[0]}
                        id="tags-standard"
                        options={agencyNameOptions}
                        getOptionLabel={(option) => option.agency}

                        onChange={handleAgencyName}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Agency Name*"
                                placeholder="Select"
                                error={isAgencyNameEmpty}
                            />
                        )}
                    />

                </Grid>
                <Grid item xs={4}>
                    <Autocomplete
                        defaultValue={(props.brandNameList.filter((value) => value.id == props.editableReportData.brandid))[0]}
                        id="tags-standard"
                        options={props.brandNameList}
                        getOptionLabel={(option) => option.brandName}
                        onChange={handleBrandName}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Brand Name*"
                                placeholder="Select"
                                error={isBrandNameEmpty}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        defaultValue={searchEngineOption}
                        options={searchEngineOptions}
                        disableCloseOnSelect
                        onChange={handleSearchEngine}
                        getOptionLabel={(option) => option.title}
                        getOptionSelected={(option, value) => option.value === value.value}
                        renderOption={(option, { selected }) => (
                            <React.Fragment>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.title}
                            </React.Fragment>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label="Search Engine" placeholder="Select" />
                        )}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Autocomplete
                        value={advertiser}
                        defaultValue={advertiser}
                        multiple
                        onChange={(event, value, reason, details) => setAdvertiser(value)}
                        id="tags-standard"
                        options={props.brandUrl}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Advertiser"
                                placeholder="Select"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Autocomplete
                        value={brandedUrl}
                        defaultValue={brandedUrl}
                        multiple
                        onChange={(event, value, reason, details) => setBrandedUrl(value)}
                        id="tags-standard"
                        options={props.brandedUrl}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Branded URL"
                                placeholder="Select"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <div className="text-right1 bt-1 pt-2">
                        <Button
                        disabled={btnStatus}
                            onClick={handleReportSubmit}
                            variant="contained"
                            color='secondary'
                            type='submit'
                        >Submit</Button>
                        <Button
                            onClick={() => props.resetEditId()}
                            variant="contained"
                            type='submit'
                            style={{ marginLeft: "20px" }}
                        >Cancel</Button>
                    </div>
                </Grid>
            </Grid>
        </div>
    </>
}

export default EditableAutomationReportSystem;

